import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Icd10Code } from 'src/app/core/models/icd10-code';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { Icd10CodeService } from 'src/app/core/services/general/icd10-code.service';

@Component({
  selector: 'app-search-icd10-code',
  templateUrl: './search-icd10-code.component.html',
  styleUrls: ['./search-icd10-code.component.scss']
})
export class SearchIcd10CodeComponent {
  public loading = true;
  public initialLoading = true;
  public icd10CodesList!: Array<Icd10Code>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'code', direction: 'asc' },
    'icd10_codes'
  );

  public sortColumns = [
    'code',
    'short_description',
    'long_description',
    'status',
    'priority',
  ];

  constructor(
    private router: Router,
    private icd10CodeService: Icd10CodeService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.icd10CodeService
      .search(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.icd10CodesList = res.data.map((u) => new Icd10Code(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(icd10Code: Icd10Code) {
    this.activeModal.close(icd10Code);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
